import Construction from '../Assets/UnderConsruction.jpg'

const SliderData = [
    {
      image: Construction
    }
  ];
  
  export default SliderData